module.exports = __webpack_public_path__ + "img/yiruntong2.b41a9ebe.svg";